export default __webpack_public_path__ + "static/media/icons8-hide-96.e81e6659.svg";